// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3JpDG","content":"RecentSearches_content__3NHO4"};